// import Dashboard from '../index';
import Type42A from '../Type42A';
import Type43A from '../Type43A';
// import Type58 from '../Type58';
import Type10A from '../Type10A';
import Type48A from '../Type48A';
import Type49 from '../Type49';
import Type50A from '../Type50A';
import Type20A from '../Type20A';
import Type40 from '../Type40';
import Type44A from '../Type44A';
import Type82 from '../Type82';
import Type83 from '../Type83';
import Type84 from '../Type84';
import Type85 from '../Type85';
import Type86 from '../Type86';
import Type87 from '../Type87';
import Type88 from '../Type88';
import Type89 from '../Type89';
import Type90 from '../Type90';
import Type91 from '../Type91';
import Type92 from '../Type92';
import Type93 from '../Type93';
import Type94 from '../Type94';
import Type131 from '../Type131';

const routes = [
  {
    path: '/olympic/admin/classes/3/types/type42A',
    name: 'Type 1 (RD) - Type 42A',

    component: Type42A,

    layout: '/lms',
    exact: true,
  },
  {
    path: '/olympic/admin/classes/3/types/type43A',
    name: 'Type 2 (RD) - Type 43A',

    component: Type43A,

    layout: '/lms',
    exact: true,
  },
  // {
  //   path: '/olympic/admin/classes/3/types/type58',
  //   name: 'Type 3 (RD) - Type 58',

  //   component: Type58,

  //   layout: '/lms',
  //   exact: true,
  // },
  {
    path: '/olympic/admin/classes/3/types/type10A',
    name: 'Type 4 (RD) - Type 10A',

    component: Type10A,

    layout: '/lms',
    exact: true,
  },
  {
    path: '/olympic/admin/classes/3/types/type48A',
    name: 'Type 7 (RD) - Type 48A',

    component: Type48A,

    layout: '/lms',
    exact: true,
  },
  {
    path: '/olympic/admin/classes/3/types/type49',
    name: 'Type 8 (RD) - Type 49',

    component: Type49,

    layout: '/lms',
    exact: true,
  },
  {
    path: '/olympic/admin/classes/3/types/type50A',
    name: 'Type 9 (RD) - Type 50A',

    component: Type50A,

    layout: '/lms',
    exact: true,
  },
  {
    path: '/olympic/admin/classes/3/types/type20A',
    name: 'Type 10 (RD) - Type 20A',

    component: Type20A,

    layout: '/lms',
    exact: true,
  },
  {
    path: '/olympic/admin/classes/3/types/type40',
    name: 'Type 12 (RD) - Type 40',

    component: Type40,

    layout: '/lms',
    exact: true,
  },
  {
    path: '/olympic/admin/classes/3/types/type44A',
    name: 'Type 15 (RD) - Type 44A',

    component: Type44A,

    layout: '/lms',
    exact: true,
  },
  {
    path: '/olympic/admin/classes/3/types/type82',
    name: 'Type 17 (RD) - Type 82',

    component: Type82,

    layout: '/lms',
    exact: true,
  },
  {
    path: '/olympic/admin/classes/3/types/type83',
    name: 'Type 18 (RD) - Type 83',

    component: Type83,

    layout: '/lms',
    exact: true,
  },
  {
    path: '/olympic/admin/classes/3/types/type84',
    name: 'Type 19 (RD) - Type 84',

    component: Type84,

    layout: '/lms',
    exact: true,
  },
  {
    path: '/olympic/admin/classes/3/types/type85',
    name: 'Type 20 (RD) - Type 85',

    component: Type85,

    layout: '/lms',
    exact: true,
  },
  {
    path: '/olympic/admin/classes/3/types/type86',
    name: 'Type 21 (RD) - Type 86',

    component: Type86,

    layout: '/lms',
    exact: true,
  },
  {
    path: '/olympic/admin/classes/3/types/type87',
    name: 'Type 22 (RD) - Type 87',

    component: Type87,

    layout: '/lms',
    exact: true,
  },
  {
    path: '/olympic/admin/classes/3/types/type88',
    name: 'Type 23 (RD) - Type 88',

    component: Type88,

    layout: '/lms',
    exact: true,
  },
  {
    path: '/olympic/admin/classes/3/types/type89',
    name: 'Type 24 (RD) - Type 89',

    component: Type89,

    layout: '/lms',
    exact: true,
  },
  {
    path: '/olympic/admin/classes/3/types/type90',
    name: 'Type 25 (RD) - Type 90',

    component: Type90,

    layout: '/lms',
    exact: true,
  },
  {
    path: '/olympic/admin/classes/3/types/type91',
    name: 'Type 26 (RD) - Type 91',

    component: Type91,

    layout: '/lms',
    exact: true,
  },
  {
    path: '/olympic/admin/classes/3/types/type92',
    name: 'Type 27 (RD) - Type 92',

    component: Type92,

    layout: '/lms',
    exact: true,
  },
  {
    path: '/olympic/admin/classes/3/types/type93',
    name: 'Type 28 (RD) - Type 93',

    component: Type93,

    layout: '/lms',
    exact: true,
  },
  {
    path: '/olympic/admin/classes/3/types/type94',
    name: 'Type 29 (RD) - Type 94',

    component: Type94,

    layout: '/lms',
    exact: true,
  },
  {
    path: '/olympic/admin/classes/3/types/type131',
    name: 'Type 30 (RD) - Type 131',

    component: Type131,

    layout: '/lms',
    exact: true,
  },
];

export default routes;
